<template>
  <AddStBaseApplicant
    :add-statement="addStatement"
    :title="title"
    @send="saveDraft"
  >
    <template #footer="{ next }">
      <div>
        <slot
          name="footer"
          :next="next"
          :is-save-loading="isSaveDraftLoading"
        ></slot>
      </div>
    </template>
  </AddStBaseApplicant>
</template>

<script>
import { RouteText } from '@/router';
import { AddStModule } from '@/store/modules/alternativeServices/additionalStatement';
import { Role } from '@/utils/dictionaries';
import { FieldGroup } from '@/utils/fullStatementView';
import { ApplicantRoleConst, SubjectFillType } from '@/constants';
import { StatementType } from '@/types/services';
import AddStBaseApplicant from './AddStBaseApplicant';

export default {
  name: 'AddStApplicant',
  props: {
    addStatement: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
    },
  },
  components: {
    AddStBaseApplicant,
  },
  data() {
    return {
      FieldGroup,
      Role,
      RouteText,
    };
  },
  computed: {
    applicant() {
      return this.addStatement?.applicant;
    },

    person() {
      return this.applicant?.person;
    },

    organization() {
      return this.applicant?.organization;
    },

    foreignOrganization() {
      return this.applicant?.foreignOrganization;
    },

    role() {
      if (this.person) return Role.PERSON;
      if (this.organization) return Role.ORGANIZATION;
      if (this.foreignOrganization) return Role.FOREIGN_ORGANIZATION;

      throw new Error('Заявитель не найден');
    },

    trusteeInfo() {
      return this.applicant[this.role].trusteeInfo;
    },

    assignee() {
      return this.applicant[this.role].assignee;
    },

    trustee() {
      return this.trusteeInfo || this.assignee;
    },

    isManual() {
      if (
        this.addStatement.originalStatementType === StatementType.EXTRACTION_ROD
      ) {
        return this.addStatement.applicantRole === ApplicantRoleConst.APPLICANT;
      }

      return (
        this.addStatement?.applicant?.uiContext?.fillType ===
        SubjectFillType.MANUAL
      );
    },

    isSaveDraftLoading() {
      return AddStModule.saveDraftState.loading;
    },
  },
  methods: {
    async saveDraft(trustee) {
      try {
        const addStatement = await AddStModule.saveDraft({
          initialAddSt: this.addStatement,
          trustee,
          role: this.role,
        });
        this.$emit('save', addStatement);
      } catch (e) {
        await this.$vuetify.goTo('#header-target', { duration: 200 });
        throw e;
      }
    },
  },
};
</script>
